import axios from 'axios'
import Vue from 'vue'
import router from '@/router'
import * as cognosLaunch from '../utils/cognoslaunch.js';


const HTTP_API = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: { 'Content-Type': 'application/json' }
})
/*
* The interceptor here ensures that we check for the token in local storage every time an ajax request is made
*/
HTTP_API.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('web-token')
    var currentDate = new Date();
    if (currentDate.getTime() < sessionStorage.getItem('expDate')) {
      config.headers['Authorization'] = `Bearer ${ token }`
    } else {
      
      if (!config.url.includes('forgotPassword') && !config.url.includes('resetPassword') 
      && !config.url.includes('token') && !config.url.includes('login') && !config.url.includes('qr')) {
        cognosLaunch.logoffCognos();
        setTimeout(() => {
          window.location.href = "/CR/"
        }, 1000)
      }
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

HTTP_API.interceptors.response.use(
  (response) => {
    console.log(response)
    return response
  },
  (error) => {
    if (error == 'Error: Network Error')
      router.push({ name: 'login' })
    return Promise.reject(error)
  }
)

export default HTTP_API
